import { render, staticRenderFns } from "./RichHtml.vue?vue&type=template&id=fbfab258&scoped=true&"
import script from "./RichHtml.vue?vue&type=script&lang=js&"
export * from "./RichHtml.vue?vue&type=script&lang=js&"
import style0 from "./RichHtml.vue?vue&type=style&index=0&id=fbfab258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfab258",
  null
  
)

export default component.exports